import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { TERMS_VERSION } from "@/lib/terms";
import api from "@/lib/api";

export const TermsNotice = () => {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!user || done || user.terms_ack_version === TERMS_VERSION) return null;
  const accept = async () => {
    setBusy(true);
    try { await api.post("/auth/terms-ack"); setDone(true); refresh?.(); }
    catch { setDone(true); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open>
      <DialogContent className="max-w-lg bg-white [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="terms-notice">
        <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-nm-coral">Before you dive in</div>
        <DialogTitle className="font-serif text-3xl text-nm-ink font-normal">Welcome to your toolkit</DialogTitle>
        <DialogDescription asChild>
          <div className="space-y-3 text-sm text-nm-neutral leading-relaxed">
            <p>This toolkit is for education. It isn't legal, HR, medical, or mental-health advice, so please use your own judgment in applying it to your situation.</p>
            <p>We only use your information to run your account and deliver your toolkit, and we never sell it. Use what you learn and your completed templates to support your team. Your full access is a single-user license, so if you'd like someone else to have the full toolkit, please get them their own copy.</p>
            <p>By using this toolkit, you agree to the{" "}
              <a href="/terms" target="_blank" rel="noreferrer" data-testid="terms-notice-link" className="font-medium text-nm-primary underline underline-offset-2 hover:text-nm-coral">Terms &amp; Privacy</a>.</p>
          </div>
        </DialogDescription>
        <div><button onClick={accept} disabled={busy} data-testid="terms-notice-continue"
          className="mt-2 w-full rounded-full bg-nm-coral py-3 text-sm font-semibold text-white hover:opacity-90 transition-opacity duration-200 disabled:opacity-50">
          {busy ? "One moment…" : "Got it — take me to my toolkit"}
        </button></div>
      </DialogContent>
    </Dialog>
  );
};
